import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import NeedHelpButton from './NeedHelpButton';
import { getLinksWrapperStyles } from './NeedHelpSx';

// Icons.
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';

const NeedHelpWidget = () => {
  const { t } = useTranslation();

  const links = {
    bloxUniversity: 'https://www.university.bloxdigital.com/',
    updates: 'https://www.bloxdigital.com/resources/new_in_nxt/',
    documentation: 'https://www.help.bloxdigital.com/',
    gettingStarted: 'https://www.university.bloxdigital.com/blox_nxt/',
    support: 'https://www.bloxdigital.com/support/',
  };

  const openLink = (link: string) => {
    window.open(link, '_blank', 'noopener noreferrer');
  };

  // Translation strings
  const strTitle = t('blox.dashboards.needHelp.title');
  const strNeedHelpTitle = t('blox.dashboards.needHelp.title');
  const strResources = t('blox.dashboards.needHelp.resources');
  const strBloxUniTitle = t('blox.dashboards.needHelp.bloxUniversity.title');
  const strBloxUniSubtitle = t('blox.dashboards.needHelp.bloxUniversity.subtitle');
  const strDocsTitle = t('blox.dashboards.needHelp.documentation.title');
  const strDocsSubtitle = t('blox.dashboards.needHelp.documentation.subtitle');
  const strSupportTitle = t('blox.dashboards.needHelp.support.title');
  const strSupportSubtitle = t('blox.dashboards.needHelp.support.subtitle');
  const strUpdatesTitle = t('blox.dashboards.needHelp.updates.title');
  const strUpdatesSubtitle = t('blox.dashboards.needHelp.updates.subtitle');

  return (
    <Paper
      variant="outlined"
      sx={{ p: 2 }}
    >
      <Typography
        variant="subtitle2"
        gutterBottom
      >
        {strTitle}
      </Typography>

      {/* Getting started link. */}
      <Box sx={(theme) => getLinksWrapperStyles(theme)}>
        <Button
          href={links.gettingStarted}
          component="a"
          target="_blank"
          rel="noopener noreferrer"
          endIcon={<OpenInNewRoundedIcon />}
          sx={{ fontWeight: 400, textDecoration: 'underline' }}
          data-testid="need-help-btn-link"
        >
          {strNeedHelpTitle}
        </Button>
      </Box>

      <br />

      {/* Resources. */}
      <Typography
        variant="subtitle2"
        gutterBottom
      >
        {strResources}
      </Typography>

      <Stack spacing={1}>
        {/* NXT/Blox University */}
        <NeedHelpButton
          data-testid="help-university-button"
          title={strBloxUniTitle}
          subtitle={strBloxUniSubtitle}
          startIcon={<SchoolRoundedIcon fontSize="large" />}
          onClick={() => openLink(links.bloxUniversity)}
        />
        {/* Documentation. */}
        <NeedHelpButton
          data-testid="help-documentation-button"
          title={strDocsTitle}
          subtitle={strDocsSubtitle}
          startIcon={<SearchRoundedIcon fontSize="large" />}
          endIcon={<OpenInNewRoundedIcon fontSize="large" />}
          onClick={() => openLink(links.documentation)}
        />
        {/* Support */}
        <NeedHelpButton
          data-testid="help-support-button"
          title={strSupportTitle}
          subtitle={strSupportSubtitle}
          startIcon={<QuestionMarkRoundedIcon fontSize="large" />}
          onClick={() => openLink(links.support)}
        />
        {/* Latest Updates. */}
        <NeedHelpButton
          data-testid="help-whats-new-button"
          title={strUpdatesTitle}
          subtitle={strUpdatesSubtitle}
          onClick={() => openLink(links.updates)}
        />
      </Stack>
    </Paper>
  );
};

export default NeedHelpWidget;
